export enum EMobile {
  reigsterUserNotifications = 'mobile/user-notifications',
  updateUserNotificationKey = 'mobile/update-notification-key',
}
